/**
 * GET /v1/incidents/:publicId — request params + snapshot response.
 */

import { z } from 'zod'

export { IncidentSnapshotResponseSchema, type IncidentSnapshotResponse } from './common'

export const GetIncidentParamsSchema = z.object({
  publicId: z.string().min(1)
})
export type GetIncidentParams = z.infer<typeof GetIncidentParamsSchema>
